import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { actions, Form } from "react-redux-form";
import { routerActions } from "react-router-redux";
import Alert from "react-s-alert";
import ReactTable, { RowInfo } from "react-table";
import * as ReactTooltip from "react-tooltip";
import { bindActionCreators } from "redux";
import * as NavigationActions from "../../../actions/navigation";
import * as ToggleActions from "../../../actions/pages/togglePage";
import * as TrialActions from "../../../actions/trial";
import * as TrialInstitutionItemCustomViewActions from "../../../actions/trialInstitutionItemCustomView";
import { NotificationAlert } from "../../../components/common/index";
import {
    CustomFormInput, PrimitiveFormInput
} from "../../../components/form/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons
} from "../../../constants/fontAwesomeIcons";
import {
    DEFAULT_PAGE_SIZE,
    PAGE_SIZE_OPTIONS
} from "../../../constants/reactTableConstants";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import {
    renderRegistrationFormSaveBlock,
    renderRegistrationFormSaveSuccess,
    renderRegistrationFormSaveWarning
} from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { TrialInstitutionItemCustomViewBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { CollectionInstanceDataState, collectionInstanceIsValid, validateCollectionInstance } from "../../../helpers/collectionInstanceHelper";
import {
    renderFormControls
} from "../../../helpers/formHelper";
import { TrialSubMenu } from "../../../helpers/subMenuHelper";
import RouterHoc, {
    IRouterActions,
    IRouterProps
} from "../../../hoc/RouterHoc";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { TogglePageItem } from "../../../reducers/pages/togglePage";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import {
    initialTrialInstitutionItemCustomViewState, ITrialInstitutionItemCustomViewReduxFormState
} from "../../../reducers/reactReduxForms/trialInstitutionItemCustomView";
import { TrialLayout } from "../../index";
import "./TrialInstitutionItemCustomViewDataEntryPage.scss";


interface ITrialInstitutionItemCustomViewDataEntryPageParams {
    trialId: number;
    trialInstitutionItemCustomViewId: number;
}

interface ITrialInstitutionItemCustomViewDataEntryPageProps
    extends IRouterProps<ITrialInstitutionItemCustomViewDataEntryPageParams> {
    form: Dtos.TrialInstitutionItemCustomView & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITrialInstitutionItemCustomViewReduxFormState;

    trialId: number;
    trialInstitutionItemCustomViewId: number;

    // From state
    trialInstitutionItemCustomView: Dtos.TrialInstitutionItemCustomView;
    trial: Dtos.Trial;
    lookups: Dtos.Lookup[];

    loadingTrial: boolean;
    loadTrialSuccess: boolean;
    loadTrialFailure: boolean;
    loadTrialErrorCode: string;

    loadingTrialInstitutionItemCustomView: boolean;
    loadTrialInstitutionItemCustomViewSuccess: boolean;
    loadTrialInstitutionItemCustomViewFailure: boolean;
    loadTrialInstitutionItemCustomViewErrorCode: string;

    savingTrialInstitutionItemCustomView: boolean;
    saveTrialInstitutionItemCustomViewSuccess: boolean;
    saveTrialInstitutionItemCustomViewFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    toggleItems: TogglePageItem[];
}

interface ITrialInstitutionItemCustomViewDataEntryPageActions
    extends IRouterActions {
    clearTrialInstitutionItemCustomView: TrialInstitutionItemCustomViewActions.ITrialInstitutionItemCustomViewClearActionCreator;
    loadTrialInstitutionItemCustomView: TrialInstitutionItemCustomViewActions.ITrialInstitutionItemCustomViewLoadDataEntryByIdActionCreator;
    saveTrialInstitutionItemCustomView: TrialInstitutionItemCustomViewActions.ITrialInstitutionItemCustomViewSaveDataEntryActionCreator;

    clearTrial: TrialActions.ITrialClearActionCreator;
    loadTrial: TrialActions.ITrialLoadByIdActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    toggleExpand: ToggleActions.IToggleExpandedStateActionCreator;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type TrialInstitutionItemCustomViewDataEntryPageProps =
    ITrialInstitutionItemCustomViewDataEntryPageProps &
        ITrialInstitutionItemCustomViewDataEntryPageActions;

interface ITrialInstitutionItemCustomViewDataEntryPageState {
    collectionInstanceDataStates: CollectionInstanceDataState[];
    byInstitution: boolean;
    isValid: boolean;
    compactTextArea: boolean;
}

const reduxFormName: string = "reduxForms.trialInstitutionItemCustomView";

class TrialInstitutionItemCustomViewDataEntryPage extends React.PureComponent<
    TrialInstitutionItemCustomViewDataEntryPageProps,
    ITrialInstitutionItemCustomViewDataEntryPageState
> {
    initialised: boolean;
    constructor(props: TrialInstitutionItemCustomViewDataEntryPageProps) {
        super(props);

        this.state = {
            collectionInstanceDataStates: [],
            isValid: true,
            byInstitution: false,
            compactTextArea: false,
        };

        this.clearTrialInstitutionItemCustomView =
            this.clearTrialInstitutionItemCustomView.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadTrialInstitutionItemCustomView,
            trialInstitutionItemCustomViewId,
            trialId,
            loadTrial,
            setDrawerItems,
            permissions,
            setBreadcrumbs
        } = this.props;
        

        setDrawerItems(TrialSubMenu(trialId, permissions));
        setBreadcrumbs(TrialInstitutionItemCustomViewBreadcrumbs(trialId));

        if (trialInstitutionItemCustomViewId) {
            loadTrialInstitutionItemCustomView(
                trialInstitutionItemCustomViewId
            );
        } else if (!trialInstitutionItemCustomViewId) {
            this.onCancel();
        }
        loadTrial(trialId);
    }

    componentDidUpdate(
        prevProps: TrialInstitutionItemCustomViewDataEntryPageProps,
        prevState
    ) {
        const {
            form,
            trialId,
            trialInstitutionItemCustomViewId,
            trialInstitutionItemCustomView,
            loadTrialInstitutionItemCustomView,
            loadTrial,
            loadingTrialInstitutionItemCustomView,
            loadTrialInstitutionItemCustomViewSuccess,
            validationFailures,
            navigate,
            trial,
            setBreadcrumbs,
            permissions,
            setDrawerItems,
            savingTrialInstitutionItemCustomView,
            saveTrialInstitutionItemCustomViewSuccess,
            loadTrialFailure,
            loadTrialInstitutionItemCustomViewFailure,
            loadTrialInstitutionItemCustomViewErrorCode,
            loadTrialErrorCode,
        } = this.props;

        if (loadTrialFailure) {
            navigate(`/error/${loadTrialErrorCode}`);
        }
        if (loadTrialInstitutionItemCustomViewFailure) {
            navigate(`/error/${loadTrialInstitutionItemCustomViewErrorCode}`);
        }

        if (trial?.displayName && !this.initialised) {
            setDrawerItems(TrialSubMenu(trialId, permissions));
            setBreadcrumbs(TrialInstitutionItemCustomViewBreadcrumbs(trialId));
            this.initialised = true;
        }

        if (trialId && prevProps.trialId != trialId) {
            loadTrial(trialId);
        }

        if (
            trialInstitutionItemCustomViewId &&
            prevProps.trialInstitutionItemCustomViewId !=
                trialInstitutionItemCustomViewId
        ) {
            loadTrialInstitutionItemCustomView(
                trialInstitutionItemCustomViewId
            );
        }

        if (JSON.stringify(form) != JSON.stringify(prevProps.form)) {
            let collectionInstanceDataStates = validateCollectionInstance(
                form.itemComponentWithDatas,
                savingTrialInstitutionItemCustomView
            );
            let isValid = collectionInstanceIsValid(
                collectionInstanceDataStates
            );
            this.setState({ collectionInstanceDataStates, isValid });
        }

        if (
            !loadingTrialInstitutionItemCustomView &&
            prevProps.loadingTrialInstitutionItemCustomView
        ) {
            if (loadTrialInstitutionItemCustomViewSuccess) {
                this.loadForm();
                this.setState({
                    compactTextArea:
                        trialInstitutionItemCustomView.compactTextArea,
                });
            }
        }

        if (
            !savingTrialInstitutionItemCustomView &&
            prevProps.savingTrialInstitutionItemCustomView
        ) {
            if (saveTrialInstitutionItemCustomViewSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveWarning(
                                validationFailures
                            )}
                            icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        />
                    );

                    // toggleMessageModal();
                } else {
                    Alert.success(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveSuccess()}
                            icon={FontAwesomeIcons.Solid.CHECK}
                        />
                    );
                }
                if (form.saveAndReturn) {
                    navigate(
                        "/trials/" + trialId + "/trialinstitutionitemviews"
                    );
                } else if (
                    !form.saveAndReturn &&
                    trialInstitutionItemCustomViewId &&
                    trialInstitutionItemCustomViewId > 0
                ) {
                    this.loadForm();
                }
            } else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }
    }

    componentWillUnmount() {
        const { resetForm, loadForm } = this.props;

        this.clearTrialInstitutionItemCustomView();
        loadForm(reduxFormName, initialTrialInstitutionItemCustomViewState);
        resetForm(reduxFormName);
    }

    clearTrialInstitutionItemCustomView() {
        this.props.clearTrialInstitutionItemCustomView();
        this.props.clearTrial();
    }

    showTrialInstitutionItemCustomView(): boolean {
        const {
            loadingTrial,
            loadingTrialInstitutionItemCustomView,
            loadTrialInstitutionItemCustomViewSuccess,
        } = this.props;

        if (
            !loadingTrial &&
            !loadingTrialInstitutionItemCustomView &&
            loadTrialInstitutionItemCustomViewSuccess
        ) {
            return true;
        }

        return false;
    }

    render() {
        const { loadingTrial, loadingTrialInstitutionItemCustomView } =
            this.props;

        return (
            <TrialLayout
                loading={loadingTrial || loadingTrialInstitutionItemCustomView}
                permission={Dtos.Permission.TrialItemUpdate}
            >
                {this.renderContent()}
            </TrialLayout>
        );
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            permissions,
            savingTrialInstitutionItemCustomView,
        } = this.props;

        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermission(
                form,
                permissions,
                Dtos.Permission.TrialItemUpdate,
                Dtos.Permission.TrialItemCreate
            );
        const formDisabled: boolean =
            !this.state.isValid ||
            savingTrialInstitutionItemCustomView ||
            !hasPermission ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {};

        return (
            <div style={{ position: "relative" }}>
                <div
                    style={{
                        position: "absolute",
                        left: "10px",
                        right: "10px",
                    }}
                >
                    <Form
                        model={reduxFormName}
                        onSubmit={(val, event) => this.handleOnSubmit(val)}
                        onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
                    >
                        <div className="row">
                            <div className={"col mb-2"}>
                                <h1>
                                    {" "}
                                    {form
                                        ? form.name
                                        : "Institution Items View"}
                                </h1>
                            </div>
                            <div className="col-auto">
                                <div className="mt-4 mb-4 text-right">
                                    <button
                                        onClick={() => {
                                            this.setState({
                                                byInstitution:
                                                    !this.state.byInstitution,
                                            });
                                        }}
                                        disabled={
                                            savingTrialInstitutionItemCustomView
                                        }
                                        type="button"
                                        className="btn btn-secondary mr-2"
                                        data-tip={"Pivot columns and rows"}
                                    >
                                        <FontAwesomeIcon
                                            icon={
                                                FontAwesomeIcons.Regular.REPEAT
                                            }
                                            fixedWidth
                                        />
                                        <ReactTooltip />
                                    </button>
                                    <button
                                        onClick={() => {
                                            this.setState({
                                                compactTextArea:
                                                    !this.state.compactTextArea,
                                            });
                                        }}
                                        disabled={
                                            savingTrialInstitutionItemCustomView
                                        }
                                        type="button"
                                        className="btn btn-secondary mr-2"
                                        data-tip={
                                            this.state.compactTextArea
                                                ? "Show expanded controls"
                                                : "Show compact controls"
                                        }
                                    >
                                        {this.state.compactTextArea ? (
                                            <FontAwesomeIcon
                                                icon={
                                                    FontAwesomeIcons.Solid
                                                        .HAMBURGER
                                                }
                                                fixedWidth
                                            />
                                        ) : (
                                            <FontAwesomeIcon
                                                icon={
                                                    FontAwesomeIcons.Solid.DASH
                                                }
                                                fixedWidth
                                            />
                                        )}
                                        <ReactTooltip />
                                    </button>
                                    <button
                                        disabled={formDisabled}
                                        onClick={() => {
                                            this.props.changeForm(
                                                reduxFormName +
                                                    ".saveAndReturn",
                                                false
                                            );
                                        }}
                                        type="submit"
                                        className="btn btn-primary mr-2"
                                    >
                                        Submit
                                    </button>

                                    <button
                                        disabled={formDisabled}
                                        onClick={() => {
                                            this.props.changeForm(
                                                reduxFormName +
                                                    ".saveAndReturn",
                                                true
                                            );
                                        }}
                                        type="submit"
                                        className="btn btn-primary mr-2"
                                    >
                                        Submit And Return
                                    </button>
                                    <button
                                        onClick={this.onCancel}
                                        className="btn btn-primary mr-2"
                                    >
                                        {" "}
                                        Cancel{" "}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className={"col mb-2"}>
                                <p> {form ? form.description : ""}</p>
                            </div>
                        </div>
                        <div className="container-fluid">
                            {renderFormControls(
                                form,
                                "trialInstitutionItemCustomView",
                                formComponents,
                                lookups,
                                validationFailures,
                                formProperties,
                                changeForm
                            )}
                        </div>

                        {this.showTrialInstitutionItemCustomView()
                            ? this.state.byInstitution
                                ? this.createTableByInstitution()
                                : this.createTableByItemComponentPrimitive()
                            : null}

                        <div className="mt-4 mb-4 text-right">
                            <button
                                disabled={formDisabled}
                                onClick={() => {
                                    this.props.changeForm(
                                        reduxFormName + ".saveAndReturn",
                                        false
                                    );
                                }}
                                type="submit"
                                className="btn btn-primary mr-2"
                            >
                                Submit
                            </button>

                            <button
                                disabled={formDisabled}
                                onClick={() => {
                                    this.props.changeForm(
                                        reduxFormName + ".saveAndReturn",
                                        true
                                    );
                                }}
                                type="submit"
                                className="btn btn-primary mr-2"
                            >
                                Submit And Return
                            </button>
                            <button
                                onClick={this.onCancel}
                                className="btn btn-primary mr-2"
                            >
                                {" "}
                                Cancel{" "}
                            </button>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }

    createTableByItemComponentPrimitive() {
        const { permissions, lookups, form } = this.props;

        if (
            !form ||
            !form.trialItemDataEntryByInstitutions ||
            form.trialItemDataEntryByInstitutions.length == 0
        ) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>There are currently no trial institutions</span>
                    </div>
                </div>
            );
        }

        const showPagination =
            form.trialItemDataEntryByInstitutions.length > DEFAULT_PAGE_SIZE;

        let columns: any[] = [
            /*{
            id: "id",
            Header: ' ',
            accessor: "id",
            className: "d-flex align-items-center justify-content-center",
            maxWidth: 50,
            Cell: (props) => <div className="large-small-icon"><FontAwesomeIcon className="large-icon" icon={FontAwesomeIcons.Light.TRIAL} fixedWidth />{(props.original.parentInstitutionId && props.original.parentInstitutionId > 0) ? <FontAwesomeIcon className="medium-icon" icon={FontAwesomeIcons.Light.INSTITUTION} fixedWidth /> : <></>}<FontAwesomeIcon className="small-icon" icon={FontAwesomeIcons.Light.INSTITUTION} fixedWidth /></div>
        },*/
            {
                id: "institutionDisplay",
                Header: () => (
                    <span>
                        <br />
                        Institution
                    </span>
                ),
                accessor: "institutionDisplay",
                minWidth: 250,
            },
        ];

        if (
            form.customDataEntryColumns &&
            form.customDataEntryColumns.length > 0
        ) {
            let previousTrialItem: string = " ";
            let displayTrialItem: boolean = true;
            form.customDataEntryColumns.forEach((column, columnIndex) => {
                if (previousTrialItem != column.trialItem) {
                    displayTrialItem = true;
                    previousTrialItem = column.trialItem;
                } else {
                    displayTrialItem = false;
                }
                columns.push({
                    id: columnIndex.toString(),
                    Header: () => (
                        <p className="m-0">
                            <small>
                                {column.isFirstTrialItem
                                    ? column.trialItem
                                    : ""}
                            </small>
                            <br />
                            {column.columnName}
                        </p>
                    ),
                    accessor: "id",
                    className: "d-flex align-items-left justify-content-left",
                    headerClassName: "text-left",
                    minWidth: 250,
                    Cell: (props) => {
                        const cellIndex =
                            props.original.trialItemDataEntryColumns[
                                Number(props.column.id)
                            ]?.itemComponentWithDataIndex;
                        return (
                            <div style={{ display: "block", width: "100%" }}>
                                {this.renderCell(
                                    cellIndex,
                                    cellIndex ? `${reduxFormName}.itemComponentWithDatas[${cellIndex.toString()}].collectionInstanceData` : "",
                                    false
                                )}
                            </div>
                        );
                    },
                });
            });
        }

        return (
            <div className="card">
                <div className="table-wrapper">
                    <ReactTable
                        data={form.trialItemDataEntryByInstitutions}
                        pageSizeOptions={PAGE_SIZE_OPTIONS}
                        defaultPageSize={
                            showPagination
                                ? DEFAULT_PAGE_SIZE
                                : form.trialItemDataEntryByInstitutions.length
                        }
                        pageSize={
                            showPagination
                                ? undefined
                                : form.trialItemDataEntryByInstitutions.length
                        }
                        showPagination={showPagination}
                        className="-striped -highlight -clickable"
                        noDataText="There are currently no trial institutions to display"
                        resizable={false}
                        getTdProps={(
                            _state,
                            _rowInfo: RowInfo,
                            _column,
                            _instance
                        ) => {
                            return {
                                onClick: (e, handleOriginal) => {
                                    if (handleOriginal) {
                                        handleOriginal();
                                    }
                                },
                            };
                        }}
                        defaultSorted={[
                            {
                                id: "name",
                                desc: false,
                            },
                        ]}
                        columns={columns}
                        //style={{ height: "400px" }}
                    />
                </div>
            </div>
        );
    }

    createTableByInstitution() {
        const { form } = this.props;

        if (
            !form ||
            !form.trialItemDataEntryByItemComponentPrimitives ||
            form.trialItemDataEntryByItemComponentPrimitives.length == 0
        ) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>There are currently no trial institutions</span>
                    </div>
                </div>
            );
        }

        const showPagination =
            form.trialItemDataEntryByInstitutions.length > DEFAULT_PAGE_SIZE;

        let columns: any[] = [
            /*{
            id: "id",
            Header: ' ',
            accessor: "id",
            className: "d-flex align-items-center justify-content-center",
            maxWidth: 50,
            Cell: (props) => <div className="large-small-icon"><FontAwesomeIcon className="large-icon" icon={FontAwesomeIcons.Light.TRIAL} fixedWidth />{(props.original.parentInstitutionId && props.original.parentInstitutionId > 0) ? <FontAwesomeIcon className="medium-icon" icon={FontAwesomeIcons.Light.INSTITUTION} fixedWidth /> : <></>}<FontAwesomeIcon className="small-icon" icon={FontAwesomeIcons.Light.INSTITUTION} fixedWidth /></div>
        },*/
            {
                id: "display",
                Header: () => (
                    <span>
                        <br />
                        Item Component
                    </span>
                ),
                accessor: "display",
                minWidth: 250,
                Cell: (props) => {
                    if (props.original.isFirstTrialItem) {
                        return (
                            <div>
                                <small>{props.original.trialItem}</small>
                                <br />
                                {props.value}
                            </div>
                        );
                    }
                    return <div>{props.value}</div>;
                },
            },
        ];

        if (form.trialInstitutions && form.trialInstitutions.length > 0) {
            form.trialInstitutions.forEach((column, columnIndex) => {
                columns.push({
                    id: columnIndex.toString(),
                    Header: () => <span>{column.institutionDisplay}</span>,
                    accessor: "id",
                    className: "d-flex align-items-left justify-content-left",
                    headerClassName: "text-left",
                    minWidth: 250,
                    Cell: (props) => {
                        const cellIndex =
                            props.original.trialItemDataEntryColumns[
                                Number(props.column.id)
                            ]?.itemComponentWithDataIndex;
                        return (
                            <div style={{ display: "block", width: "100%" }}>
                                {this.renderCell(
                                    cellIndex,
                                    cellIndex ? `${reduxFormName}.itemComponentWithDatas[${cellIndex.toString()}].collectionInstanceData` : "",
                                    false
                                )}
                            </div>
                        );
                    },
                });
            });
        }

        return (
            <div className="card">
                <div className="table-wrapper">
                    <ReactTable
                        data={form.trialItemDataEntryByItemComponentPrimitives}
                        pageSizeOptions={PAGE_SIZE_OPTIONS}
                        defaultPageSize={
                            showPagination
                                ? DEFAULT_PAGE_SIZE
                                : form
                                      .trialItemDataEntryByItemComponentPrimitives
                                      .length
                        }
                        pageSize={
                            showPagination
                                ? undefined
                                : form
                                      .trialItemDataEntryByItemComponentPrimitives
                                      .length
                        }
                        showPagination={showPagination}
                        className="-striped -highlight -clickable"
                        noDataText="There are currently no trial institutions to display"
                        resizable={false}
                        getTdProps={(
                            _state,
                            _rowInfo: RowInfo,
                            _column,
                            _instance
                        ) => {
                            return {
                                onClick: (e, handleOriginal) => {
                                    if (handleOriginal) {
                                        handleOriginal();
                                    }
                                },
                            };
                        }}
                        defaultSorted={[
                            {
                                id: "name",
                                desc: false,
                            },
                        ]}
                        columns={columns}
                    />
                </div>
            </div>
        );
    }

    renderCell(
        itemComponentWithDataIndex: number,
        reduxFormNameParent: string,
        locked: boolean
    ) {
        const { changeForm, form, savingTrialInstitutionItemCustomView } =
            this.props;

        if (itemComponentWithDataIndex == -1) {
            return <></>;
        }

        let itemComponentWithData: Dtos.ItemComponentWithData =
            form.itemComponentWithDatas[itemComponentWithDataIndex];

        if (
            itemComponentWithData?.collectionInstanceData &&
            itemComponentWithData?.itemComponent &&
            itemComponentWithData?.itemComponentPrimitive
        ) {
            const name =
                "itemComponentInputPrimitives_" +
                itemComponentWithData.collectionInstanceData.id;

            let collectionInstanceDataState =
                this.state.collectionInstanceDataStates.find(
                    (f) =>
                        f.id == itemComponentWithData.collectionInstanceData.id
                );
            if (collectionInstanceDataState == undefined) {
                collectionInstanceDataState = {
                    id: itemComponentWithData.collectionInstanceData.id,
                    isAnswered: false,
                    isDisabled:
                        savingTrialInstitutionItemCustomView ||
                        locked ||
                        itemComponentWithData.formLocked,
                    isRequired: false,
                    isValid: true,
                    validations: [],
                };
            }
            let primitiveItem = {
                ...itemComponentWithData.itemComponentPrimitive,
            };

            return (
                <div
                    key={
                        "itemComponent-" +
                        itemComponentWithData.collectionInstanceData.id
                    }
                    style={{ display: "block" }}
                >
                    <div
                        className={
                            itemComponentWithData.isQuestion &&
                            collectionInstanceDataState.isRequired &&
                            !collectionInstanceDataState.isAnswered
                                ? "text-danger"
                                : ""
                        }
                        style={{ width: "100%" }}
                    >
                        <PrimitiveFormInput
                            key={name}
                            item={primitiveItem}
                            id={name}
                            name={name}
                            disabled={
                                savingTrialInstitutionItemCustomView ||
                                collectionInstanceDataState.isDisabled ||
                                itemComponentWithData.collectionInstanceData
                                    .isNa
                            }
                            textValue={
                                itemComponentWithData.collectionInstanceData
                                    .textValue
                                    ? itemComponentWithData
                                          .collectionInstanceData.textValue
                                    : ""
                            }
                            bitValue={
                                itemComponentWithData.collectionInstanceData
                                    .bitValue != null
                                    ? itemComponentWithData
                                          .collectionInstanceData.bitValue
                                    : false
                            }
                            intValue={
                                itemComponentWithData.collectionInstanceData
                                    .intValue != null
                                    ? itemComponentWithData
                                          .collectionInstanceData.intValue
                                    : null
                            }
                            numberValue={
                                itemComponentWithData.collectionInstanceData
                                    .numberValue != null
                                    ? itemComponentWithData
                                          .collectionInstanceData.numberValue
                                    : null
                            }
                            dateValue={
                                itemComponentWithData.collectionInstanceData
                                    .dateValue != null
                                    ? itemComponentWithData
                                          .collectionInstanceData.dateValue
                                    : null
                            }
                            onChange={(field, value) => {
                                changeForm(
                                    reduxFormNameParent + "." + field,
                                    value
                                );
                                changeForm(
                                    reduxFormNameParent + ".isModified",
                                    true
                                );
                            }}
                            validationFailures={
                                collectionInstanceDataState.validations
                            }
                            isRequired={collectionInstanceDataState.isRequired}
                            instructions={itemComponentWithData.instructions}
                            isNaAllowed={itemComponentWithData.isNaAllowed}
                            isNa={
                                itemComponentWithData.collectionInstanceData
                                    .isNa
                            }
                            hideLabels={true}
                            compact={this.state.compactTextArea}
                            modified={
                                itemComponentWithData.collectionInstanceData
                                    .isModified
                            }
                        />
                        {/*(itemComponentWithData.isLastPrimitive && itemComponentWithData.itemComponent.sourceDocuments && itemComponentWithData.itemComponent.sourceDocuments.length) > 0 && (
                        <div className="card">
                            <div className="card-body p-3">
                                <h6 className="card-subtitle text-muted">Downloads and Documents</h6>
                                {itemComponentWithData.itemComponent.sourceDocuments.map((sourceDocument, sourceDocumentIndex) => <div className="d-flex">
                                    <div className="flex-grow-1 py-2">{sourceDocument.name}</div>
                                    <div className="p-2 text-muted"><em>{findLookupValue("ItemComponentSourceDocument", "FileType", sourceDocument.fileType, lookups)}</em></div>
                                    <div className="">{SOURCE_DOCUMENT_FILE_CONFIGURATION(form, changeForm, reduxFormName, lookups, sourceDocument, sourceDocumentIndex)}</div>
                                </div>)}
                            </div>
                        </div>
                    )*/}
                    </div>
                </div>
            );
        }

        if (
            itemComponentWithData?.itemComponent &&
            itemComponentWithData?.itemComponent?.customInputControlName != ""
        ) {
            return (
                <CustomFormInput
                    item={itemComponentWithData.itemComponent}
                    id={
                        "itemComponent_" +
                        itemComponentWithData.itemComponent.id +
                        "_" +
                        itemComponentWithData.itemComponent
                            .customInputControlName
                    }
                    name={
                        "itemComponent_" +
                        itemComponentWithData.itemComponent.id +
                        "_" +
                        itemComponentWithData.itemComponent
                            .customInputControlName
                    }
                />
            );
        }
    }

    // Used for rules data lookup
    /*findItemComponentWithData(
        trialItemInstitutionsIndex: number, // CHANGE TO collectionInstanceId
        id: number) {
        const {
            form
        } = this.props;

        let result: Dtos.ItemComponentWithData = null;

        
         form.column1.forEach(item => {
             if (item.itemComponentPrimitive && item.itemComponentPrimitive.id == id) {
                 result = item;
             }
         });
 
         form.column2.forEach(item => {
             if (item.itemComponentPrimitive && item.itemComponentPrimitive.id == id) {
                 result = item;
             }
         });
 
         form.column3.forEach(item => {
             if (item.itemComponentPrimitive && item.itemComponentPrimitive.id == id) {
                 result = item;
             }
         });
         

        return result;
    }*/

    renderErrorAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was <strong> not </strong> saved.
            </div>
        );
    }

    renderWarningAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was saved but was invalid with{" "}
                {validationFailures.length} errors.
            </div>
        );
    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>;
    }

    handleOnSubmit(data: Dtos.TrialInstitutionItemCustomView) {
        const { saveTrialInstitutionItemCustomView } = this.props;

        if (data) {
            let changes: Dtos.TrialInstitutionItemCustomView =
                {} as Dtos.TrialInstitutionItemCustomView;
            saveTrialInstitutionItemCustomView(
                Object.assign({ ...data }, changes)
            );
        }
    }

    handleOnSubmitFailed(_data: Dtos.Trial) {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    }

    onCancel() {
        const { trialId, navigate } = this.props;

        navigate("/trials/" + trialId + "/trialinstitutionitemviews");
    }

    loadForm() {
        const { loadForm, trialInstitutionItemCustomView } = this.props;

        let extraData: Dtos.TrialInstitutionItemCustomView =
            {} as Dtos.TrialInstitutionItemCustomView;

        loadForm(
            reduxFormName,
            Object.assign({ ...trialInstitutionItemCustomView }, extraData)
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: TrialInstitutionItemCustomViewDataEntryPageProps
): ITrialInstitutionItemCustomViewDataEntryPageProps => {
    let trial: Dtos.Trial | undefined = !(
        state.trials.formData instanceof Array
    )
        ? state.trials.formData
        : undefined;
    let trialInstitutionItemCustomView:
        | Dtos.TrialInstitutionItemCustomView
        | undefined = !(
        state.trialInstitutionItemCustomView.formData instanceof Array
    )
        ? state.trialInstitutionItemCustomView.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];
    let trialItemSelections = trialInstitutionItemCustomView
        ? trialInstitutionItemCustomView.trialItemSelections
        : [];

    return {
        match: ownProps.match,
        trialId: ownProps.match ? ownProps.match.params.trialId : undefined!,
        trialInstitutionItemCustomViewId:
            ownProps.match &&
            ownProps.match.params.trialInstitutionItemCustomViewId.toString() !=
                "create"
                ? ownProps.match.params.trialInstitutionItemCustomViewId
                : undefined!,

        history: ownProps.history,
        location: ownProps.location,

        trialInstitutionItemCustomView: trialInstitutionItemCustomView!,
        trial: trial!,

        loadingTrialInstitutionItemCustomView:
            state.trialInstitutionItemCustomView.loadState &&
            state.trialInstitutionItemCustomView.loadState.status ==
                RequestState.Pending,
        loadTrialInstitutionItemCustomViewSuccess:
            state.trialInstitutionItemCustomView.loadState &&
            state.trialInstitutionItemCustomView.loadState.status ==
                RequestState.Success,
        loadTrialInstitutionItemCustomViewFailure:
            state.trialInstitutionItemCustomView.loadState &&
            state.trialInstitutionItemCustomView.loadState.status ==
                RequestState.Failure,
        loadTrialInstitutionItemCustomViewErrorCode:
            state.trialInstitutionItemCustomView.loadState.errorCode,

        savingTrialInstitutionItemCustomView:
            state.trialInstitutionItemCustomView.saveState &&
            state.trialInstitutionItemCustomView.saveState.status ==
                RequestState.Pending,
        saveTrialInstitutionItemCustomViewSuccess:
            state.trialInstitutionItemCustomView.saveState &&
            state.trialInstitutionItemCustomView.saveState.status ==
                RequestState.Success,
        saveTrialInstitutionItemCustomViewFailure:
            state.trialInstitutionItemCustomView.saveState &&
            state.trialInstitutionItemCustomView.saveState.status ==
                RequestState.Failure,

        loadingTrial:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Pending,
        loadTrialSuccess:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Success,
        loadTrialFailure:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Failure,
        loadTrialErrorCode: state.trials.loadState.errorCode,

        user: state.user.data,
        permissions: permissions,
        lookups: state.trialInstitutionItemCustomView.lookups,

        form: state.reduxForms.trialInstitutionItemCustomView,
        formState: state.trialInstitutionItemCustomView.formState,
        formProperties: state.trialInstitutionItemCustomView.formProperties,

        reduxFormState:
            state.reduxForms.formState.trialInstitutionItemCustomView,
        validationFailures: state.trialInstitutionItemCustomView.formData
            ? state.trialInstitutionItemCustomView.validationFailures
            : undefined,

        toggleItems: state.togglePage.items,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: TrialInstitutionItemCustomViewDataEntryPageProps
): ITrialInstitutionItemCustomViewDataEntryPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadTrialInstitutionItemCustomView: bindActionCreators(
            TrialInstitutionItemCustomViewActions.LoadTrialInstitutionItemCustomViewDataEntryById,
            dispatch
        ),
        clearTrialInstitutionItemCustomView: bindActionCreators(
            TrialInstitutionItemCustomViewActions.Clear,
            dispatch
        ),
        saveTrialInstitutionItemCustomView: bindActionCreators(
            TrialInstitutionItemCustomViewActions.SaveTrialInstitutionItemCustomViewDataEntry,
            dispatch
        ),

        loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
        clearTrial: bindActionCreators(TrialActions.Clear, dispatch),

        toggleExpand: bindActionCreators(
            ToggleActions.ToggleExpanded,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<
    ITrialInstitutionItemCustomViewDataEntryPageParams,
    TrialInstitutionItemCustomViewDataEntryPageProps
>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        TrialInstitutionItemCustomViewDataEntryPage
    ) as unknown as ComponentType<TrialInstitutionItemCustomViewDataEntryPageProps>
) as ComponentType<any>;
